<template>
  <!-- eslint-disable -->
  <div>
    <b-row class="mb-2">
      <b-col sm="9">
        <b-button variant="danger"  @click.prevent="back">
          Atras
        </b-button>
      </b-col>
      <b-col sm="3" class="text-right">
        <b-button variant="success"  @click.prevent="acceptMovement()">
          Aceptar Movimiento
        </b-button>
      </b-col>
    </b-row>
    <b-row v-if="datosMov">
      <b-col sm="12">
        <b-card no-body header-bg-variant="dark">
          <b-card-header class="border-b-2 bg-secondary">
            <h4 class="text-white">Información de Movimiento</h4>
          </b-card-header>
          <b-card-body class="mt-2">
            <b-row>
              <b-col sm="6" lg="3" class="flex">
                <strong>Tienda Destino: </strong>
                <p class="mt-50">{{ datosMov.establishmentDestiny.name }}</p>
              </b-col>
              <b-col sm="6" lg="3" class="flex">
                <strong>Tienda Origen: </strong>
                <p class="mt-50">{{ datosMov.establishmentOrigin.name }}</p>
              </b-col>
              <b-col sm="4" lg="2" class="flex mr-5">
                <strong>Número de documento: </strong>
                <p class="mt-50">{{ datosMov.documentCode }}</p>
              </b-col>
              <b-col sm="6" lg="3" class="flex">
                <strong>Transportista: </strong>
                <v-select
                  v-model="selectedUserId"
                  :options="userOptions"
                  label="fullname"
                  :reduce="user => user.id"
                  placeholder="Seleccionar Usuario"
                />
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-card no-body>
          <b-card-header class="bg-secondary border-b-2">
            <h4 class="text-white">Detalles de Movimiento</h4>
          </b-card-header>
          <b-card-text class="">
            <b-table
              class="position-relative"
              :hover="true"
              :items="details"
              responsive
              :fields="fields"
              show-empty
              empty-text="No existen"
              @sort-changed="sortChanged"
            >
            <template v-slot:cell(qty_received)="{ item, index,field: { key } }">
              <b-input-group>
                <b-form-input v-model.number="item[key]" style="width: 150px" type="number"  @keypress="validateValue(item, index,$event)" />
              </b-input-group>
            </template>
            </b-table>
            <div class="mx-2 mb-2">
              <b-row>
                <b-col sm="3">
                  <b-form-group label-cols="4" label-cols-md="4" label-size="md" label="Entradas" label-for="input-md">
                    <b-form-select
                      v-model="showEntrie"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="title"
                      :options="entries"
                    />
                  </b-form-group>
                </b-col>
                <b-col sm="3" class="mt-75" style="font-size: 12px">
                  <span> {{ totalElements }} Registros en total</span>
                </b-col>
                <!-- Pagination -->
                <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="totalElements"
                    :per-page="showEntrie"
                    class="mb-0 mt-1 mt-sm-0"
                    prev-class="prev-item"
                    next-class="next-item"
                    @change="cambioPagina"
                  >
                    <template #prev-text>
                      <feather-icon icon="ChevronLeftIcon" size="18" />
                    </template>
                    <template #next-text>
                      <feather-icon icon="ChevronRightIcon" size="18" />
                    </template>
                  </b-pagination>
                </b-col>
              </b-row>
            </div>
          </b-card-text>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from 'vue'
import { BootstrapVue, BootstrapVueIcons, VBTooltip } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import InternalMovement from '@/services/InternalMovement'
import UserService from '@/services/UserService'
import vSelect from 'vue-select'
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
export default {
  directives: {
    'b-tooltip': VBTooltip,
    Ripple
  },
  components: {
    vSelect
  },
  data() {
    return {
      datosMov: null,
      details: [],
      userOptions: [],
      selectedUserId: 1,
      fields: [
        { key: 'autopart.uniqueCode', label: 'Código Único', sortable: true },
        { key: 'autopart.originalCode', label: 'Codigo Original', sortable: true },
        { key: 'autopart.alterCode', label: 'Codigo Alter.', sortable: true },
        { key: 'autopart.description', label: 'Descripción', sortable: false },
        { key: 'qty', label: 'Cantidad', sortable: true },
      ],
      arrayFilters: [],
      currentPage: 1,
      entries: [10, 20, 50, 100],
      showEntrie: 10,
      totalElements: 0,
      id: 0,
      sort: 'id',
      order: 'desc'
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async acceptMovement(){
      this.$swal({
        title: '¿Desea confirmar/recibir este movimiento?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Si, confirmar',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1'
        },
        buttonsStyling: false
      }).then(async (result) => {
        if (result.value) {
          var form = { 
            documentCode: this.datosMov.documentCode,
            description: this.datosMov.description,
            establishmentOriginId: this.datosMov.establishmentOrigin.id,
            establishmentDestinyId: this.datosMov.establishmentDestiny.id,
            state: "Despachado",
            userReceiverId:  this.selectedUserId
          }

          const resp = await InternalMovement.updateProcess(this.$route.params.id, form, this.$store)
          if (resp.error == false) {
            this.$swal({
              icon: 'success',
              title: 'Confirmado!',
              text: 'El movimiento ha sido recibido.',
              customClass: {
                confirmButton: 'btn btn-success'
              }
            })
            this.$router.push('/inventario/entrada/bandeja-destino/')
          } else {
            this.$swal({
              icon: 'error',
              title: 'Error!',
              text: 'Ocurrió un error al recibir el movimiento.',
              customClass: {
                confirmButton: 'btn btn-success'
              }
            })
          }
        }
      })
    },

    onlyNumbers(e) {
      if ((e.keyCode >= 48 && e.keyCode <= 57) || e.keyCode == 46) {
        return true
      } else {
        e.preventDefault()
      }
    },

    cambioPagina(e) {
      this.currentPage = e
    },

    sortChanged(data) {
      this.sort = data.sortBy
      if (data.sortDesc) {
        this.order = 'desc'
      } else this.order = 'asc'
    },

    back() {
      this.$router.push('/inventario/entrada/bandeja-destino/')
    },

    async getData() {
      var resp = await InternalMovement.getMovInternal(this.$route.params.id, this.$store)
      const url = `?limit=${this.showEntrie}&page=${this.currentPage}&order=${this.order}&sort=${this.sort}&filter=${JSON.stringify(this.arrayFilters)}`;
      this.details = []
      if (resp.data) {
        this.datosMov = resp.data.internalMovement
        this.details = resp.data.internalDetail
        this.totalElements = resp.data.internalDetail.length
      }

      this.arrayFilters.push({
        keyContains: 'userEstablishments.some',
        key: 'establishmentId',
        value: this.datosMov.establishmentDestiny.id
      });
      
      const response = await UserService.getUsers(url, this.$store);
      if (!response.error) {
        this.userOptions = response.data.rows;
      }
    }
  }
}
</script>

<style></style>
